import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IIncidentCode, IncidentCodeService } from '@shared/services/incident-code-service';

@Component({
	selector: 'app-delete-incident-code',
	templateUrl: './delete-incident-code.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeleteIncidentCodeComponent {
	@Output() deleted: EventEmitter<any> = new EventEmitter();
	httpError: string = '';
	loading: boolean | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public incidentCode: IIncidentCode,
		public dialogRef: MatDialogRef<DeleteIncidentCodeComponent>,
		private service: IncidentCodeService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';

		this.service.delete(this.incidentCode.id).subscribe({
			next: () => {
				this.deleted.emit(this.incidentCode.id);
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
